import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import CallingPointsService from '../services/CallingPointsService';
import CallingPointsStore from '../stores/CallingPointsStore';

const inFlightRequests = new Map();

const CallingPointsActions = {

    async getFromService (service) {
        const cached = CallingPointsStore.get(service);

        if (cached) {
            return cached;
        }

        const { callingPoints } = service.journey;

        if (inFlightRequests.has(callingPoints)) {
            return inFlightRequests.get(callingPoints);
        }

        AppDispatcher.dispatch({
            actionType: ActionTypes.CALLING_POINTS_LOAD_STARTED,
            key: callingPoints
        });

        const request = CallingPointsService.get(callingPoints)
            .then((result) => {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.CALLING_POINTS_LOADED,
                    key: callingPoints,
                    callingPoints: result
                });
                return result;
            })
            .catch((error) => {
                AppDispatcher.dispatch({
                    actionType: ActionTypes.CALLING_POINTS_LOAD_FAILED,
                    key: callingPoints
                });
                throw error;
            })
            .finally(() => {
                inFlightRequests.delete(callingPoints);
            });

        inFlightRequests.set(callingPoints, request);

        return request;
    },

    loadForDisplay (service) {
        // Display surfaces render their fallback from CALLING_POINTS_LOAD_FAILED;
        // the rejection must not escalate to the global error modal.
        return this.getFromService(service).catch(() => {});
    },

    async getCallingPointsForServices (...services) {
        // keep positions stable so a missing outward service can't shift the
        // return service's calling points into the outward slot
        const [outwardCallingPoints, returnCallingPoints] = await Promise.all(
            services.map(service => (service ? this.getFromService(service) : null))
        );

        return { outwardCallingPoints, returnCallingPoints };
    }

};

export default CallingPointsActions;
